module.exports = __webpack_public_path__ + "static/img/guide.c5fce4d7.svg";